import type { MultiValueTags } from 'types/tags'

export const grafanaQueryKeys = {
  getMonitors: (params: {
    grafanaIntegrationName: string
    searchString: string
    teamId: string
  }) => ['grafana/monitors', params] as const,
  getRuleInstances: (params: {
    integrationName: string
    multiSelectTags: MultiValueTags
    ruleUid: string
    teamId: string
  }) => ['grafana/rule-instances', params] as const
}
